import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ComingSoon({ title, subtitle }) {
    return (
        <main
            data-testid="coming-soon-page"
            className="relative flex min-h-[100svh] items-center justify-center overflow-hidden bg-rz-bg px-6 pt-24 pb-16"
        >
            <div
                className="absolute inset-0 opacity-[0.08]"
                style={{
                    backgroundImage: "url('/images/barn-exterior.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="relative z-10 mx-auto max-w-2xl text-center">
                <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                    Bientôt disponible
                </span>
                <h1 className="font-display mt-5 text-[clamp(2.4rem,6vw,4.5rem)] font-extrabold tracking-tighter leading-[1] text-rz-ink">
                    {title}
                </h1>
                <p className="mt-6 text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                    {subtitle}
                </p>
                <Link
                    to="/"
                    data-testid="coming-soon-back"
                    className="group mt-10 inline-flex items-center gap-2 rounded-full bg-rz-green px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-rz-deep"
                >
                    <ArrowLeft
                        size={17}
                        className="transition-transform duration-300 group-hover:-translate-x-1"
                    />
                    Retour à l'accueil
                </Link>
            </div>
        </main>
    );
}
